import React from 'react'
import cx from 'classnames'

import Text from 'components/_new/typography/Text/Text'
import RadioButton from 'components/forms/RadioButton/RadioButton'

import s from './RadioOption.scss'


const RadioOption = ({ children, name, isActive, activeOptionLink, label, hasError, dataTestId, ariaLabelledBy: _ariaLabelledBy }) => {
  const radioClassName = cx(s.radio, {
    [s.error]: hasError,
    [s.active]: isActive,
  })

  const labelId = `opt_${name}Label`
  const ariaLabelledBy = _ariaLabelledBy ? `${_ariaLabelledBy} ${labelId}` : labelId

  return (
    <RadioButton className={radioClassName} brand key={name} value={name} dataTestId={dataTestId} ariaLabelledBy={ariaLabelledBy}>
      <div onClick={() => activeOptionLink.set(name)}>
        <Text id={labelId} message={label} size="14-24" color="black" />
        {children}
      </div>
    </RadioButton>
  )
}

export default RadioOption
